import { StepDef } from "@/app/wizard/wizard-types";

export function shouldExcludeDocument(
  fromLocation: string | undefined,
  franceDocs: boolean,
  portugalDocs: boolean,
  spainDocs: boolean,
  current: StepDef
): boolean {
  if (
    !current.brandSpecificParams?.isEnableFromLocationDocs &&
    (franceDocs || portugalDocs || spainDocs)
  ) {
    return true;
  }
  if (fromLocation === "ES" && (franceDocs || portugalDocs)) {
    return true;
  }
  if (fromLocation === "PT" && (franceDocs || spainDocs)) {
    return true;
  }
  if (fromLocation === "FR" && (spainDocs || portugalDocs)) {
    return true;
  }
  return false;
}
